import React, { ReactNode, useRef, useState } from 'react'

import { Menu, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'

// import DownloadCsvTableMenuItem from './DownloadCsvTableMenuItem'
import Iconify from '../../Iconify/Iconify'

import TableMoreMenuItem from './TableMoreMenuItem'

// ----------------------------------------------------------------------

type TableMoreMenuPropTypes = {
  onEdit?: () => void
  onDelete?: () => void
  onDownloadPdf?: () => void
  // onDownloadCsv: () => void
  // csv: {
  //   data: string[]
  //   headers: string[]
  //   filename: string
  // },
  onToggleIsActive?: () => void
  isActive?: boolean
  children?: ReactNode
}

const TableMoreMenu: React.FC<TableMoreMenuPropTypes> = ({
  onDelete,
  onEdit,
  onDownloadPdf,
  // onDownloadCsv,
  onToggleIsActive,
  isActive,
  // csv,
  children,
}) => {
  const { t } = useTranslation()
  const ref = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  if (!onDelete && !onEdit && !onToggleIsActive && !onDownloadPdf && !children) return null

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="bi:three-dots-vertical" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {children}

        {onEdit && (
          <TableMoreMenuItem onClick={onEdit} icon={'bi:pencil-square'} color="info.main">
            {t('button.edit')}
          </TableMoreMenuItem>
        )}

        {onToggleIsActive && (
          <TableMoreMenuItem
            onClick={onToggleIsActive}
            // icon={isActive ? 'bi:toggle-off' : 'bi:toggle-on'}
            icon={'bi:power'}
          >
            {isActive ? t('button.deactivate') : t('button.activate')}
          </TableMoreMenuItem>
        )}

        {onDownloadPdf && (
          <TableMoreMenuItem onClick={onDownloadPdf} icon={'bi:filetype-pdf'}>
            {t('button.downloadPDF')}
          </TableMoreMenuItem>
        )}

        {/* {onDownloadCsv && (
          <TableMoreMenuItem onClick={onDownloadCsv} icon={'bi:filetype-csv'}>
            {t('button.downloadCSV')}
          </TableMoreMenuItem>
        )} */}

        {/* {csv && (
          <DownloadCsvTableMenuItem data={csv.data} headers={csv.headers} filename={csv.filename} />
        )} */}

        {onDelete && (
          <TableMoreMenuItem onClick={onDelete} icon={'bi:trash'} color="error.main">
            {t('button.delete')}
          </TableMoreMenuItem>
        )}
      </Menu>
    </>
  )
}

export default TableMoreMenu
